import * as Yup from 'yup';
import LocationComponent from '../../../reportproblem/components/selectOptions/LocationComponent';
import ServiceType from '../selectoptions/ServiceType';

export const validationSchema = Yup.object().shape({
  serviceType: Yup.string().required('Odaberite jednu od ponuđenih opcija'),
  locationComponent: Yup.string().required(
    'Odaberite jednu od ponuđenih opcija',
  ),
  wsActivity: Yup.string().when(['serviceType'], {
    is: (val1) => val1 === ServiceType.VODOVOD.value.toString(),
    then: (schema) => schema.required('Odaberite jednu od ponuđenih opcija'),
    otherwise: (schema) => schema.notRequired(),
  }),
  sewerageType: Yup.string().when(['serviceType', 'locationComponent'], {
    is: (val1, val2) =>
      val1 === ServiceType.KANALIZACIJA.value.toString() &&
      val2 !== LocationComponent.NEPOZNATO.value.toString(),
    then: (schema) => schema.required('Odaberite jednu od ponuđenih opcija'),
    otherwise: (schema) => schema.notRequired(),
  }),
  sewerageActivity: Yup.string().when(['serviceType', 'locationComponent'], {
    is: (val1, val2) =>
      val1 === ServiceType.KANALIZACIJA.value.toString() &&
      val2 !== LocationComponent.NEPOZNATO.value.toString(),
    then: (schema) => schema.required('Odaberite jednu od ponuđenih opcija'),
    otherwise: (schema) => schema.notRequired(),
  }),
  report: Yup.string().required('Unesite izvještaj'),
  startDate: Yup.date().required('Odaberite datum i vrijeme'),
  endDate: Yup.date().required('Odaberite datum i vrijeme'),
});

export const initialValues = {
  serviceType: '',
  locationComponent: '',
  sewerageType: '',
  wsActivity: '',
  sewerageActivity: '',
  report: '',
  note: '',
  startDate: null,
  endDate: null,
};
